export default __webpack_public_path__ + "static/media/map.09e56b1e.png";